import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})


export class AppComponent implements OnInit {
    title = 'chettinadlink';
    public file_path: string = "";
    templateAuthView = false;
    constructor(private router: Router) { }

    ngOnInit(): void {

    }

    onActivate(event) {
        this.file_path = this.router.url;
        if (localStorage.getItem('token') != null && localStorage.getItem('token') != undefined) {

            this.templateAuthView = false;

        }
        else {
            this.templateAuthView = true;
            this.router.navigate(['/login']);
        }
    }


}
